import type { ProjectState } from 'app/store/project/project.state';
import { createSelector } from '@ngrx/store';
import { selectProjectState } from 'app/store/project/project.state';

export const orderFieldMapState = createSelector(
  selectProjectState,
  state => state.orderFieldMap,
);

export const orderFieldMap = createSelector(
  selectProjectState,
  (state: ProjectState) => state.orderFieldMap.fieldMap,
);
